import { TemplateElement, html, defineElement } from '@webtides/element-js';
import style from './loading-spinner.css';

export default class LoadingSpinner extends TemplateElement {
    constructor() {
        super({ shadowRender: false, styles: [style] });
    }

    properties() {
        return {
            loading: false,
        };
    }

    template() {
        return html`
            <div class="lds-dual-ring"></div>
        `;
    }
}

defineElement('loading-spinner', LoadingSpinner);
